import React, { useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Button, Text } from '@fragments';
import { IconArrowLeft } from '@tabler/icons-react';
import Composer from '../../components/Composer';
import StudioAi from '../../components/StudioAi';
import InterestReel from './components/InterestReel';
import OnboardingThread from './components/OnboardingThread';
import Landing from './components/Landing';
import './styles.scss';

// Before sign-in the home is a landing page around the same @. Without a creator
// profile the home starts from the @ (guided onboarding); once
// the account is confirmed the hero gives way to the questions and the composer
// slides down with them, pinned at the foot of the scrolling canvas. With the profile
// it is the usual prompt. Connecting another profile runs the same onboarding, with
// a way back to creating.
export default function Home({ studio: s }) {
  const { t, onboarding: o } = s;
  const scroller = useRef(null);
  if (s.landing) return <Landing studio={s} />;
  const interests = [t('interestWellness'), t('interestFitness'), t('interestSports')];
  const handleFirst = o.stage === 'handle' || o.stage === 'confirm';
  const subtitle = o.adding ? 'onboardingAddSubtitle' : handleFirst ? 'onboardingSubtitle' : 'subtitle';
  return <motion.div ref={scroller} className={`studio-home ${o.conversation ? 'is-onboarding' : ''}`} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
    <AnimatePresence initial={false} mode="popLayout">
      {o.conversation ? <OnboardingThread key="onboarding" studio={s} scroller={scroller} /> : <motion.div key="hero" className="studio-hero"
        initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }}>
        <StudioAi size={56} />
        <InterestReel interests={interests} />
        <div className="studio-hero__title"><Text.h1 weight={400} contrast={9}>{t('title')}</Text.h1><Text.h1 weight={400} contrast={6}>{t('titleSecond')}</Text.h1></div>
        <div className="studio-hero__subtitle">
          <Text.p contrast={7}>{t(subtitle)}</Text.p>
          <Text.p contrast={6}>{t(`${subtitle}Second`)}</Text.p>
        </div>
      </motion.div>}
    </AnimatePresence>
    <motion.div layout="position" className="studio-creation" transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}>
      <Composer studio={s} />
      {o.adding && handleFirst && <div className="studio-creation__back">
        <Button variant="text" color="overlay" size="small" startIcon={<IconArrowLeft />} onClick={o.stopAdding}>{t('onboardingAddCancel')}</Button>
      </div>}
    </motion.div>
  </motion.div>;
}
